import React from "react";
import sImg1 from "../../images/event/flower.svg";

interface EventItem {
  title: string;
  etitle1: string;
  etitle2: string;
  etitle3: string;
  time1: string;
  time2: string;
  time3: string;
}

interface EventSectionProps {
  className?: string;
}

const Events: EventItem[] = [
  {
    title: "The Day Before",
    etitle1: "Event One",
    etitle2: "Event Two",
    etitle3: "Event Three",
    time1: "03:00 PM",
    time2: "05:00 PM",
    time3: "08:00 PM",
  },
  {
    title: "The Wedding Day",
    etitle1: "Ceremony",
    etitle2: "Reception",
    etitle3: "Farewell",
    time1: "03:00 PM",
    time2: "05:00 PM",
    time3: "08:00 PM",
  },
  {
    title: "The Day After",
    etitle1: "Event One",
    etitle2: "Event Two",
    etitle3: "Event Three",
    time1: "03:00 PM",
    time2: "05:00 PM",
    time3: "08:00 PM",
  },
];

const EventSection: React.FC<EventSectionProps> = ({ className }) => {
  return (
    <section className={`wpo-event-section ${className || ""}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col col-lg-6 col-md-12 col-12">
            <div className="event-left-image"></div>
          </div>
          <div className="col col-lg-6 col-md-12 col-12">
            <div className="event-right section-padding">
              <div className="event-right-wrap">
                <div className="event-title">
                  <div className="icon">
                    <img src={sImg1} alt="Event section flower icon" />
                  </div>
                  <h2 className="poort-text poort-in-right">The Plans</h2>
                </div>
                {Events.map((event, index) => (
                  <div className="event-right-items" key={index}>
                    <h3>{event.title}</h3>
                    <ul>
                      <li>
                        {event.etitle1} <span>{event.time1}</span>
                      </li>
                      <li>
                        {event.etitle2} <span>{event.time2}</span>
                      </li>
                      <li>
                        {event.etitle3} <span>{event.time3}</span>
                      </li>
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventSection;
